import { settings } from '../shared/constants';
import { get, post } from '../shared/services/FetchService';

class FsMpxPlaylistService {
    constructor(){
        this.MpxPlaylist = null;
    }

    getMpxPlaylist( endcard, limit ) {
		if (this.MpxPlaylist) {
			return this.MpxPlaylist;
        }
        this.MpxPlaylist = post( settings.MPX_PLAYLIST_URL, { "endcardFeed" : endcard, "limit": limit },
        json => {
            let data = json.data;
            return Array.isArray(data) ? data : [data];
        }, () => []);
        return this.MpxPlaylist;
    }
}

export default FsMpxPlaylistService;


// WEBPACK FOOTER //
// ./react-app-src/videoModal/FsMpxPlaylistService.js